// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__gfux9"};